import { AstNodeType, parser, recurseParen, renderer, replaceNodes } from '@thinkalpha/language-services';
import type { IndicatorRef } from '@thinkalpha/platform-ws-client/contracts/dictionary.js';

/** Takes in a parsable formula and normalizes it into a string that can be used to compare against other formulas */
export function normalizeFormula(formula: string, aliasToIdMap: Map<string, IndicatorRef>): string {
    const parserResult = parser(formula, {});

    if (!parserResult.root) {
        throw new Error('Parser result root is undefined');
    }

    const root = parserResult.root;
    const recursedRoot = recurseParen(root);
    const newRoot = replaceNodes(root, (node) => {
        if (!node) return node;
        if (node.type !== AstNodeType.call) return node;
        if (node === recursedRoot) return { ...node, source: 'self' }; // no name for root node

        const ref = aliasToIdMap.get(node.source);
        // arbitrary ### prefix that's invalid syntax to protect against collisions
        return { ...node, source: '###' + (ref ? ref.id.replaceAll('-', '') : node.source) };
    });
    return renderer(newRoot, false);
}

/** Takes in a parsable formula and prints it in a uniformly readable way */
export function humanizeFormula(formula: string): string {
    const parserResult = parser(formula, {});
    if (!parserResult.root) {
        throw new Error('Parser result root is undefined');
    }

    const root = parserResult.root;
    const recursedRoot = recurseParen(root);
    const newRoot = replaceNodes(root, (node) => {
        if (!node) return node;
        if (node.type !== AstNodeType.call) return node;
        if (node === recursedRoot) return { ...node, source: '' }; // no name for root node
        return node;
    });
    return renderer(newRoot, true);
}
